<script>
    import image from '../../images/capt1.jpg'
</script>

<div class="text">
    <p>
        <font size="6"><center><span style="font-weight: 400;">Территории банд (капты)</center></font>
        Город поделён на 90 территорий в гетто. Каждая из них принадлежит одной из пяти банд —
        <b>Families</b>, <b>Ballas</b>, <b>Vagos</b>, <b>Marabunta</b>, <b>Bloods</b> — и отбирается только боем.
        Отдельной «войны за бизнес» больше нет: крыша идёт за землёй.
    </p>

    <blockquote>
        <p>
            <b>Что даёт территория.</b> Каждый час банда получает <b>2 000$</b> с территории и ещё
            <b>1 000$</b> с каждого бизнеса, который на ней стоит. Захватили землю — все бизнесы на ней
            переходят под вашу крышу, а в казну падает разовая выплата <b>25 000$</b>.
        </p>
        <p>
            <b>Как назначить капт.</b> Планшет территорий открывается командой <b>/capture</b> или клавишей
            «Территории банды» (по умолчанию «ъ», меняется в настройках управления). Нужен ранг с правом
            «Капт». Выбираете чужую территорию, время начала (не раньше чем через 15 минут и не дальше
            12 часов), состав от 2 до 10 человек, калибр и разрешены ли броня с резистом.
            Обе банды сразу получают уведомление, а территория начинает мигать на карте.
        </p>
        <p>
            <b>Как попасть на бой.</b> За 5 минут до начала подойдите к смотрящему в районе своей банды —
            он забросит вас в зону; то же делает команда <b>/tpcapture</b>. Оружие не того калибра
            придётся оставить дома. Выходить из зоны во время боя нельзя: даётся 10 секунд на возвращение.
        </p>
        <p>
            <b>Сам бой.</b> Минута на подготовку, дальше 10 минут. Побеждает сторона, сделавшая больше
            убийств; при равном счёте земля остаётся у защитников. Каждый боец победившей банды получает
            выплату, территория переходит победителю.
        </p>
        <p>
            <b>Откаты.</b> После боя банда-нападатель отдыхает час, отбитая территория неприкосновенна
            30 минут. Одновременно у банды не может быть больше трёх нападений и трёх защит.
        </p>
    </blockquote>

    <div style="display: flex; justify-content: center;">
        <img src={image} alt="Территории банд" class="contentImg"/>
    </div>
</div>
